import { Instance } from 'mobx-state-tree'
import { QuestionsResponseModelBase } from './QuestionsResponseModel.base'

/* The TypeScript type of an instance of QuestionsResponseModel */
export interface QuestionsResponseModelType extends Instance<typeof QuestionsResponseModel.Type> {}

/* A graphql query fragment builders for QuestionsResponseModel */
export {
  selectFromQuestionsResponse,
  questionsResponseModelPrimitives,
  QuestionsResponseModelSelector
} from './QuestionsResponseModel.base'

/**
 * QuestionsResponseModel
 */
export const QuestionsResponseModel = QuestionsResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
